<div class="relatorio-container">
  <h1 class="titulo-pagina">Relatórios</h1>

  <form class="filtros" (ngSubmit)="consultar()">
    <!-- Tipo de Relatório -->
    <mat-form-field appearance="outline">
      <mat-label>Tipo de Relatório</mat-label>
      <mat-select [formControl]="tipoRelatorioFC" aria-label="Tipo de Relatório">
        <mat-option *ngFor="let tipo of tiposRelatorio" [value]="tipo.valor">{{ tipo.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Unidade -->
    <mat-form-field appearance="outline">
      <mat-label>Unidade</mat-label>
      <mat-select
        [(ngModel)]="unidadesSelecionadas"
        [ngModelOptions]="{ standalone: true }"
        [compareWith]="comparaUnidade"
        [disabled]="unidadeDesabilitada"
        multiple
        aria-label="Unidade">
        <mat-option *ngFor="let unidade of listaDeUnidades" [value]="unidade">{{ unidade.nome }}</mat-option>
      </mat-select>
      <mat-hint *ngIf="unidadeDesabilitada">Unidade definida pelo seu perfil.</mat-hint>
    </mat-form-field>

    <!-- Concurso -->
    <mat-form-field appearance="outline">
      <mat-label>Concurso</mat-label>
      <mat-select [formControl]="concursoFC" aria-label="Concurso">
        <div class="busca-concurso">
          <input
            matInput
            type="text"
            [formControl]="concursoFiltroFC"
            placeholder="Buscar concurso…"
            aria-label="Buscar concurso"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()" />
        </div>
        <mat-option [value]="null">Todos os concursos</mat-option>
        <mat-option *ngFor="let c of concursosFiltrados" [value]="c.id">{{ c.titulo }}</mat-option>
        <mat-option *ngIf="concursosFiltrados.length === 0" [disabled]="true">Nenhum concurso encontrado</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Tipo de Concurso -->
    <mat-form-field appearance="outline">
      <mat-label>Tipo de Concurso</mat-label>
      <mat-select [formControl]="tipoConcursoFC" aria-label="Tipo de Concurso">
        <mat-option [value]="null">Todos os tipos</mat-option>
        <mat-option *ngFor="let item of tipoConcurso | keyvalue" [value]="item.key">{{ item.value }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Situação da Inscrição -->
    <mat-form-field appearance="outline">
      <mat-label>Situação da Inscrição</mat-label>
      <mat-select [formControl]="situacaoFC" aria-label="Situação da Inscrição">
        <mat-option [value]="null">Todas as situações</mat-option>
        <mat-option *ngFor="let item of situacaoInscricao | keyvalue" [value]="item.key">{{ item.value }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Classificação -->
    <mat-form-field appearance="outline">
      <mat-label>Classificação</mat-label>
      <mat-select [formControl]="classificacaoFC" aria-label="Classificação">
        <mat-option [value]="null">Todas as classificações</mat-option>
        <mat-option *ngFor="let item of classificacaoInscricao | keyvalue" [value]="item.key">{{ item.value }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Período de inscrição -->
    <mat-form-field appearance="outline">
      <mat-label>Inscrição de</mat-label>
      <input matInput mask="00/00/0000" placeholder="dd/mm/aaaa" [matDatepicker]="pickerInicio" [formControl]="dataInicioFC" aria-label="Data inicial da inscrição" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
      <mat-datepicker #pickerInicio></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Inscrição até</mat-label>
      <input matInput mask="00/00/0000" placeholder="dd/mm/aaaa" [matDatepicker]="pickerFim" [formControl]="dataFimFC" aria-label="Data final da inscrição" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
      <mat-datepicker #pickerFim></mat-datepicker>
    </mat-form-field>

    <!-- PCD -->
    <mat-form-field appearance="outline">
      <mat-label>PCD</mat-label>
      <mat-select [formControl]="pcdFC" aria-label="Pessoa com Deficiência">
        <mat-option [value]="null">Todos</mat-option>
        <mat-option [value]="true">Sim</mat-option>
        <mat-option [value]="false">Não</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Relatório Sintético -->
    <mat-checkbox [formControl]="sinteticoFC" color="primary" class="checkbox-sintetico">
      Relatório Sintético (apenas concursos e totais)
    </mat-checkbox>

    <!-- Ações -->
    <div class="acoes">
      <button mat-raised-button color="primary" type="submit" [disabled]="carregando">
        <mat-icon aria-hidden="true">search</mat-icon> Consultar
      </button>
      <button mat-stroked-button type="button" (click)="limparFiltros()" [disabled]="carregando">
        <mat-icon aria-hidden="true">clear</mat-icon> Limpar filtros
      </button>
      <button mat-stroked-button color="primary" type="button" (click)="gerarPdf()" [disabled]="carregando || gerandoPdf">
        <mat-icon aria-hidden="true">picture_as_pdf</mat-icon>
        {{ gerandoPdf ? 'Gerando...' : 'Gerar PDF e enviar por e-mail' }}
      </button>
    </div>
  </form>

  <!-- Área de resultado -->
  <section class="resultado" aria-live="polite">
    <p *ngIf="carregando">Carregando relatório…</p>

    <ng-container *ngIf="!carregando && relatorio">
      <p *ngIf="relatorio.concursos.length === 0">
        Nenhum concurso encontrado para os filtros selecionados.
      </p>

      <ng-container *ngIf="relatorio.concursos.length > 0">
        <!-- DASHBOARD: KPIs de totais gerais -->
        <section class="dashboard" *ngIf="totaisDashboard as tot" aria-label="Totais gerais">
          <h2 class="secao-titulo">Totais gerais <span class="universo">(todas as inscrições)</span></h2>
          <div class="kpis">
            <div class="kpi">
              <span class="kpi-rotulo">Total (todas as inscrições)</span>
              <span class="kpi-valor">{{ tot.total }}</span>
            </div>
            <div class="kpi kpi-ok">
              <span class="kpi-rotulo">Aprovados / Habilitados</span>
              <span class="kpi-valor">{{ tot.aprovados }}</span>
              <span class="kpi-sub">{{ percentual(tot.aprovados, tot.total) }} do total</span>
            </div>
            <div class="kpi kpi-erro">
              <span class="kpi-rotulo">Reprovados</span>
              <span class="kpi-valor">{{ tot.reprovados }}</span>
              <span class="kpi-sub">{{ percentual(tot.reprovados, tot.total) }} do total</span>
            </div>
            <div class="kpi kpi-alerta">
              <span class="kpi-rotulo">Não avaliados</span>
              <span class="kpi-valor">{{ tot.naoAvaliados }}</span>
              <span class="kpi-sub">{{ percentual(tot.naoAvaliados, tot.total) }} do total</span>
            </div>
          </div>
          <div class="painel-deferidos">
            <span class="painel-titulo">Inscritos deferidos <span class="universo">(somente inscrições deferidas)</span></span>
            <span class="chip">Total deferidos: <strong>{{ tot.deferidosTotal }}</strong></span>
            <span class="chip chip-pcd">Deferidos PCD: <strong>{{ tot.deferidosPcd }}</strong></span>
            <span class="chip chip-ampla">Ampla concorrência: <strong>{{ tot.deferidosAmpla }}</strong></span>
          </div>
        </section>

        <!-- BARRA DE AÇÕES: exportar/copiar + alternador de visão -->
        <section class="barra-acoes">
          <div class="exportacoes">
            <button mat-raised-button color="primary" type="button" (click)="copiarParaExcel()">
              <mat-icon aria-hidden="true">content_copy</mat-icon> Copiar para Excel
            </button>
            <button mat-stroked-button color="primary" type="button" (click)="exportarCsv()">
              <mat-icon aria-hidden="true">download</mat-icon> Exportar CSV
            </button>
          </div>
          <div class="alternador" role="group" aria-label="Alternar visão">
            <button mat-button type="button" [class.ativo]="visao === 'cards'" (click)="trocarVisao('cards')">
              <mat-icon aria-hidden="true">view_agenda</mat-icon> Por concurso
            </button>
            <button mat-button type="button" [class.ativo]="visao === 'master'" (click)="trocarVisao('master')">
              <mat-icon aria-hidden="true">table_rows</mat-icon> Tabela consolidada
            </button>
          </div>
        </section>

        <!-- VISÃO 1: QUADRO POR CONCURSO -->
        <div *ngIf="visao === 'cards'">
          <article *ngFor="let grupo of relatorio.concursos" class="concurso-bloco">
            <h2 class="concurso-titulo">
              {{ grupo.titulo }}
              <span class="concurso-sub">— {{ grupo.tipoConcurso }} — {{ grupo.unidadeSigla }}{{ grupo.campus ? ' / ' + grupo.campus : '' }}</span>
            </h2>
            <dl class="concurso-meta">
              <span *ngIf="grupo.processo" class="campo"><dt>Processo:</dt> <dd>{{ grupo.processo }}</dd></span>
              <span *ngIf="grupo.vagas != null" class="campo"><dt>Vagas:</dt> <dd>{{ grupo.vagas }}</dd></span>
              <span *ngIf="grupo.periodo" class="campo"><dt>Inscrições:</dt> <dd>{{ grupo.periodo }}</dd></span>
              <span *ngIf="grupo.dataAbertura" class="campo"><dt>Abertura:</dt> <dd>{{ grupo.dataAbertura | date: 'dd/MM/yyyy' }}</dd></span>
              <ng-container *ngIf="grupo.concursoFinalizado; else naoFinalizado">
                <span class="campo"><dt>Resultado final:</dt> <dd>{{ grupo.dataResultadoFinal ? (grupo.dataResultadoFinal | date: 'dd/MM/yyyy') : '—' }}</dd></span>
                <span class="campo"><dt>Duração:</dt> <dd>{{ grupo.diasDuracao != null ? grupo.diasDuracao + ' dia(s)' : '—' }}</dd></span>
              </ng-container>
              <ng-template #naoFinalizado>
                <span class="campo"><dt>Duração:</dt> <dd>— (concurso não finalizado)</dd></span>
              </ng-template>
            </dl>

            <!-- Tabela de candidatos: apenas no modo analítico -->
            <table *ngIf="!relatorio.sintetico" class="tabela-candidatos">
              <caption class="visually-hidden">Candidatos do concurso {{ grupo.titulo }}</caption>
              <thead>
                <tr>
                  <th scope="col">Nome</th>
                  <th scope="col">ID</th>
                  <th scope="col">PCD</th>
                  <th scope="col">Data</th>
                  <th scope="col">Situação</th>
                  <th scope="col">Classificação</th>
                  <th scope="col">Posição Final</th>
                  <th *ngIf="ehPtpp(grupo)" scope="col">Autodeclaração</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let cand of grupo.candidatos">
                  <td>{{ cand.nome }}</td>
                  <td>{{ cand.inscricaoId }}</td>
                  <td>{{ simNao(cand.pcd) }}</td>
                  <td>{{ cand.dataInscricao | date: 'dd/MM/yyyy' }}</td>
                  <td>
                    {{ cand.situacao }}
                    <span *ngIf="cand.situacaoMotivo" class="motivo">({{ cand.situacaoMotivo }})</span>
                  </td>
                  <td>
                    {{ cand.classificacao }}
                    <span *ngIf="cand.classificacaoMotivo" class="motivo">({{ cand.classificacaoMotivo }})</span>
                  </td>
                  <td>{{ cand.posicaoFinal || '—' }}</td>
                  <td *ngIf="ehPtpp(grupo)">{{ cand.autodeclaracao || '—' }}</td>
                </tr>
              </tbody>
            </table>

            <!-- Totais do concurso: dois quadros distintos -->
            <div class="totais-quadros">
              <div class="quadro-totais quadro-classificacao">
                <h3 class="totais-titulo">Classificação <span class="universo">(todas as inscrições)</span></h3>
                <div class="totais-grid">
                  <div class="total-item item-ok">
                    <span class="total-rotulo">Aprovados</span>
                    <span class="total-valor">{{ grupo.totais.aprovados }}</span>
                  </div>
                  <div class="total-item item-erro">
                    <span class="total-rotulo">Reprovados</span>
                    <span class="total-valor">{{ grupo.totais.reprovados }}</span>
                  </div>
                  <div class="total-item item-alerta">
                    <span class="total-rotulo">Não avaliados</span>
                    <span class="total-valor">{{ grupo.totais.naoAvaliados }}</span>
                  </div>
                  <div class="total-item item-neutro">
                    <span class="total-rotulo">Total</span>
                    <span class="total-valor">{{ grupo.totais.total }}</span>
                  </div>
                </div>
              </div>
              <div class="quadro-totais quadro-deferidos">
                <h3 class="totais-titulo">Inscritos deferidos <span class="universo">(somente inscrições deferidas)</span></h3>
                <div class="totais-grid">
                  <div class="total-item item-info">
                    <span class="total-rotulo">Total deferidos</span>
                    <span class="total-valor">{{ grupo.inscritos.total }}</span>
                  </div>
                  <div class="total-item item-pcd">
                    <span class="total-rotulo">Deferidos PCD</span>
                    <span class="total-valor">{{ grupo.inscritos.pcd }}</span>
                  </div>
                  <div class="total-item item-neutro">
                    <span class="total-rotulo">Ampla concorrência</span>
                    <span class="total-valor">{{ grupo.inscritos.ampla }}</span>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>

        <!-- VISÃO 2: TABELA CONSOLIDADA (MESTRE) -->
        <div *ngIf="visao === 'master'" class="consolidada">
          <!-- Analítico: candidatos de todas as seleções -->
          <table *ngIf="!relatorio.sintetico" class="tabela-candidatos tabela-consolidada">
            <caption class="visually-hidden">Tabela consolidada de candidatos</caption>
            <thead>
              <tr>
                <th scope="col">Processo</th>
                <th scope="col">Concurso</th>
                <th scope="col">Tipo de Concurso</th>
                <th scope="col" class="col-num">ID</th>
                <th scope="col">Nome</th>
                <th scope="col" class="col-num">PCD</th>
                <th scope="col" class="col-data">Data</th>
                <th scope="col">Situação</th>
                <th scope="col">Classificação</th>
                <th scope="col" class="col-num">Posição Final</th>
                <th scope="col" class="col-num">Duração (dias)</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let grupo of relatorio.concursos">
                <tr *ngFor="let cand of grupo.candidatos">
                  <td>{{ grupo.processo }}</td>
                  <td>{{ grupo.titulo }}</td>
                  <td>{{ grupo.tipoConcurso }}</td>
                  <td class="col-num">{{ cand.inscricaoId }}</td>
                  <td>{{ cand.nome }}</td>
                  <td class="col-num">{{ simNao(cand.pcd) }}</td>
                  <td class="col-data">{{ cand.dataInscricao | date: 'dd/MM/yyyy' }}</td>
                  <td>
                    {{ cand.situacao }}
                    <span *ngIf="cand.situacaoMotivo" class="motivo">({{ cand.situacaoMotivo }})</span>
                  </td>
                  <td>
                    {{ cand.classificacao }}
                    <span *ngIf="cand.classificacaoMotivo" class="motivo">({{ cand.classificacaoMotivo }})</span>
                  </td>
                  <td class="col-num">{{ cand.posicaoFinal || '—' }}</td>
                  <td class="col-num">{{ grupo.concursoFinalizado && grupo.diasDuracao != null ? grupo.diasDuracao : '—' }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>

          <!-- Sintético: concursos e totais -->
          <table *ngIf="relatorio.sintetico" class="tabela-candidatos tabela-consolidada">
            <caption class="visually-hidden">Tabela consolidada de concursos (sintético)</caption>
            <thead>
              <tr>
                <th scope="col">Processo</th>
                <th scope="col">Concurso</th>
                <th scope="col">Tipo de Concurso</th>
                <th scope="col">Unidade/Campus</th>
                <th scope="col">Período</th>
                <th scope="col" class="col-num">Duração (dias)</th>
                <th scope="col" class="col-num">Aprovados</th>
                <th scope="col" class="col-num">Reprovados</th>
                <th scope="col" class="col-num">Não avaliados</th>
                <th scope="col" class="col-num">Total</th>
                <th scope="col" class="col-num">Deferidos</th>
                <th scope="col" class="col-num">Def. PCD</th>
                <th scope="col" class="col-num">Def. ampla</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let grupo of relatorio.concursos">
                <td>{{ grupo.processo }}</td>
                <td>{{ grupo.titulo }}</td>
                <td>{{ grupo.tipoConcurso }}</td>
                <td>{{ grupo.unidadeSigla }}{{ grupo.campus ? ' / ' + grupo.campus : '' }}</td>
                <td>{{ grupo.periodo }}</td>
                <td class="col-num">{{ grupo.concursoFinalizado && grupo.diasDuracao != null ? grupo.diasDuracao : '—' }}</td>
                <td class="col-num">{{ grupo.totais.aprovados }}</td>
                <td class="col-num">{{ grupo.totais.reprovados }}</td>
                <td class="col-num">{{ grupo.totais.naoAvaliados }}</td>
                <td class="col-num">{{ grupo.totais.total }}</td>
                <td class="col-num">{{ grupo.inscritos.total }}</td>
                <td class="col-num">{{ grupo.inscritos.pcd }}</td>
                <td class="col-num">{{ grupo.inscritos.ampla }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </ng-container>
  </section>
</div>
